import { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { TextareaField } from '../../../../utils/InputField';
import { ApiUpdateInvoiceNote } from '../InvoiceConfigOperation';

function UpdateInvoiceNoteModal({ data, closeModal, handleReload }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        NoteTitle: data?.noteTitle,
        NoteDescription: data?.noteDescription
    });
    const { setMessage } = useTemplate();

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        const payload = {
            NoteTitle: formData?.NoteTitle,
            NoteDescription: formData?.NoteDescription
        };
        setLoading(true);
        ApiUpdateInvoiceNote(payload, setIsError)
            .then(({ title }) => {
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <InputField
                    label="Note Title"
                    name="NoteTitle"
                    placeholder="Type note title..."
                    formData={formData}
                    onChange={handleChange}
                />
                <TextareaField
                    label="Note Description"
                    name="NoteDescription"
                    placeholder="Type note description..."
                    formData={formData}
                    onChange={handleChange}
                    className="h-36"
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default UpdateInvoiceNoteModal;
